var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeActive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 22,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.4 7.1C0 7.9 0 8.83 0 10.7v5.82c0 2.58 0 3.87.84 4.68.83.8 2.18.8 4.87.8H6v-8a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v8h.29c2.69 0 4.04 0 4.87-.8.84-.8.84-2.1.84-4.68V10.7c0-1.86 0-2.79-.4-3.6-.38-.82-1.12-1.43-2.6-2.64l-1.42-1.18C12.92 1.1 11.58 0 10 0 8.41 0 7.08 1.1 4.42 3.28L3 4.46C1.52 5.67.8 6.28.4 7.09ZM12 22v-8a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v8z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeActive);
export default ForwardRef;